import type { Stripe } from '@stripe/stripe-js';
export function useClientStripe(): Stripe {
  const { $stripe } = useNuxtApp();

  return $stripe;
}
